function FormReactor() {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach((node) => {
                if(node.id === 'app-embed') {
                    observer.disconnect();
                    monitorShadowDOM(node);
                }
            });
        });
    });

    const monitorShadowDOM = target => {
        if(target.shadowRoot) {
            target.style.setProperty('--button-border-radius', '0px');
            target.style.setProperty('--form-field-border-radius', '0px');
        }
    };
    
    observer.observe(document.body, { childList: true, subtree: true });
};

function CollectionDynamicImage() {
    document.querySelectorAll('*[data-collection-dynamic-image]').forEach(element => {

        const [title, url, image] = [element.dataset.collectionTitle, element.dataset.collectionUrl, element.dataset.collectionDynamicImage];
        
        const target = document.getElementById('collection-banner');
        const targetImage = target.querySelector('img');
        const targetTitle = target.querySelector('span');
      
        element.addEventListener('mouseover', () => {
            targetImage.srcset = image;
            targetTitle.textContent = title;
            target.href = url;
        });
    });
};

const init = () => {
    FormReactor();
    CollectionDynamicImage();
};

document.addEventListener('DOMContentLoaded', init);